import React, { useEffect, useMemo, useState } from "react";
import MobilePage from "../../../Components/MobilePage";
import { Trans, useTranslation } from "react-i18next";
import { usePictureSets } from "../../../hooks/usePictureSets";
import makeStyles from "@mui/styles/makeStyles";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import { Link, useHistory, useRouteMatch } from "react-router-dom";
import AppBar from "../../Components/AppBar";
import YearbookPoseSelector from "@/react/Webshop/Components/YearbookPoseSelector";
import Container from "@mui/material/Container";
import EpmsImage from "@/react/components/Common/EpmsImage";
import YearbookPoseInstructions from "@/react/Webshop/Components/YearbookPoseInstructions";
import BottomBar from "../../Components/BottomBar";
import { pictureIsYearbookPoseForJobYearbookPose } from "@/react/Webshop/utils/pictureUtils";
import { generatePath } from "react-router";
import useMobileRoutes from "@/react/Webshop/Mobile/hooks/useMobileRoutes";
import ImportContactsIcon from "@mui/icons-material/ImportContacts";
const useStyles = makeStyles((theme) => ({
    root: {
        marginBottom: theme.spacing(1),
    },
    infoText: {
        color: theme.palette.primary.main,
        marginTop: 0,
        textAlign: "center",
        marginBottom: theme.spacing(2),
    },
    imageContainer: {
        height: "48px",
        display: "flex",
        fontSize: "12px",
        alignItems: "center",
        "& > img": {
            maxHeight: "100%",
            border: `1px solid ${theme.palette.primary.main}`,
            boxSizing: "border-box",
            marginRight: theme.spacing(2),
            backgroundColor: "white",
        },
    },
    noImageContainer: {
        height: "46px",
        display: "flex",
        fontSize: "12px",
        alignItems: "center",
    },
    imagePlaceholder: {
        border: `1px solid ${theme.palette.primary.main}`,
        backgroundColor: theme.palette.primary.light,
        color: theme.palette.primary.dark,
        height: "100%",
        width: "40px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        boxSizing: "border-box",
        marginRight: theme.spacing(2),
    },
    instructionsContainer: {
        position: "sticky",
        // Appbar height. Risky to have it hardcoded here!
        top: "70px",
        zIndex: 1000,
    },
    title: {
        fontSize: "30px",
        textAlign: "center",
        color: theme.palette.primary.dark,
        marginBottom: 0,
        fontWeight: 300,
    },
    subtitle: {
        fontSize: "20px",
        textAlign: "center",
        color: theme.palette.primary.dark,
        marginTop: 0,
        marginBottom: "2px",
        fontWeight: 400,
    },
    expiryString: {
        fontSize: "12px",
        textAlign: "center",
        color: theme.palette.primary.dark,
        marginTop: 0,
        fontWeight: 400,
    },
}));
const NewPictureSetYearBookPoseSelection = () => {
    const { isLoaded, currentPictureSet } = usePictureSets();
    const routes = useMobileRoutes();
    const history = useHistory();
    const { params } = useRouteMatch();
    const [t] = useTranslation();
    const classes = useStyles();
    console.log("Found picture set ", currentPictureSet, isLoaded);
    const [currentJobYearbookPoseIndex, setCurrentJobYearbookPoseIndex] = useState(null);
    const currentJobYearbookPose = useMemo(() => {
        var _a, _b;
        return ((_b = (currentJobYearbookPoseIndex !== null &&
            currentPictureSet &&
            ((_a = currentPictureSet.job.yearbookPoseSelection) === null || _a === void 0 ? void 0 : _a.poses[currentJobYearbookPoseIndex]))) !== null && _b !== void 0 ? _b : null);
    }, [currentJobYearbookPoseIndex, currentPictureSet]);
    const yearbookPosePicture = useMemo(() => {
        if (!currentPictureSet || !currentJobYearbookPose) {
            return;
        }
        return currentPictureSet.pictures.find((p) => pictureIsYearbookPoseForJobYearbookPose(p, currentPictureSet, currentJobYearbookPose));
    }, [currentPictureSet, currentJobYearbookPose]);
    useEffect(() => {
        var _a;
        if (!currentPictureSet) {
            return;
        }
        const poses = (_a = currentPictureSet.job.yearbookPoseSelection) === null || _a === void 0 ? void 0 : _a.poses;
        if (!poses) {
            return;
        }
        if (params.jobPoseUuid) {
            const jobPoseIndex = poses.findIndex((p) => p.uuid === params.jobPoseUuid);
            console.log("Found job pose index", jobPoseIndex);
            if (jobPoseIndex >= 0) {
                setCurrentJobYearbookPoseIndex(jobPoseIndex);
                return;
            }
        }
        if (poses.length === 1) {
            setCurrentJobYearbookPoseIndex(0);
        }
        if (poses.length > 1) {
            const newPath = generatePath(routes["newpictureset.yearbook-pose-section.job-pose"].path, { jobPoseUuid: poses[0].uuid });
            history.replace(newPath);
        }
    }, [currentPictureSet, params]);
    if (!isLoaded || !currentPictureSet) {
        return (React.createElement("div", null,
            React.createElement(Trans, null, "Loading..")));
    }
    console.log("Stuffs", currentJobYearbookPose, currentPictureSet);
    if (!currentPictureSet.job.yearbookPoseSelection ||
        currentPictureSet.job.yearbookPoseSelection.expired ||
        !currentJobYearbookPose ||
        // Implied fixed at this point, but typescript want them set
        !currentPictureSet.job.yearbookPoseSelection ||
        currentJobYearbookPoseIndex === null) {
        return (React.createElement(MobilePage, null,
            React.createElement(AppBar, null),
            React.createElement("p", null,
                React.createElement(Trans, null, "Yearbook pose selection has expired"))));
    }
    const poses = currentPictureSet.job.yearbookPoseSelection.poses;
    let nextPageLink = "/products/packages";
    if (poses.length - 1 > currentJobYearbookPoseIndex) {
        nextPageLink = generatePath(routes["newpictureset.yearbook-pose-section.job-pose"].path, { jobPoseUuid: poses[currentJobYearbookPoseIndex + 1].uuid });
    }
    return (React.createElement(MobilePage, null,
        React.createElement(AppBar, null),
        React.createElement(Box, { display: "flex", justifyContent: "center" },
            React.createElement(ImportContactsIcon, { sx: { color: "primary.dark", fontSize: 65 } })),
        React.createElement("h1", { className: classes.title }, currentJobYearbookPose.name),
        React.createElement("h2", { className: classes.subtitle },
            React.createElement(Trans, null, "Select yearbook pose"),
            poses.length > 1 && (React.createElement(React.Fragment, null,
                " ",
                React.createElement("span", null, t("%d of %d", {
                    postProcess: "sprintf",
                    sprintf: [currentJobYearbookPoseIndex + 1, poses.length],
                }))))),
        React.createElement("h3", { className: classes.expiryString }, currentPictureSet.job.yearbookPoseSelection.expiryDateInfoString),
        React.createElement(Box, { className: classes.instructionsContainer, mb: 2 },
            React.createElement(YearbookPoseInstructions, { pictureSet: currentPictureSet, jobYearbookPose: currentJobYearbookPose })),
        React.createElement(Container, { className: classes.root, style: { paddingBottom: "72px" } },
            React.createElement(YearbookPoseSelector, { pictureSet: currentPictureSet, jobYearbookPose: currentJobYearbookPose })),
        React.createElement(BottomBar, null,
            React.createElement(Container, null,
                React.createElement(Box, { display: "flex", justifyContent: "space-between", py: 1 },
                    React.createElement(CurrentYearbookPose, { yearbookPosePicture: yearbookPosePicture }),
                    React.createElement(Button, { component: Link, variant: "contained", color: "primary", to: nextPageLink }, yearbookPosePicture ? React.createElement(Trans, null, "Next") : React.createElement(Trans, null, "Skip")))))));
};
const CurrentYearbookPose = ({ yearbookPosePicture, }) => {
    const classes = useStyles();
    if (!yearbookPosePicture) {
        return (React.createElement("div", { className: classes.noImageContainer },
            React.createElement("div", { className: classes.imagePlaceholder }, "?"),
            React.createElement("div", null, "No picture selected")));
    }
    return (React.createElement("div", { className: classes.imageContainer },
        React.createElement(EpmsImage, { uuid: yearbookPosePicture.uuid }),
        React.createElement("div", null,
            React.createElement(Trans, null, "Picture selected"))));
};
export default NewPictureSetYearBookPoseSelection;
